module.exports = __webpack_public_path__ + "img/001.67f74050.png";